<template>
  <div class="zj-emergency-task-summary">
    <div class="task-item item1">
      <div class="task-icon-wrapper">
        <div class="task-icon"></div>
      </div>
      <div class="task-status">未完成</div>
      <div class="task-count" v-html="info.exception"></div>
    </div>
    <div class="task-item item2">
      <div class="task-icon-wrapper">
        <div class="task-icon"></div>
      </div>
      <div class="task-status">待执行</div>
      <div class="task-count" v-html="info.todo"></div>
    </div>
    <div class="task-item item3">
      <div class="task-icon-wrapper">
        <div class="task-icon"></div>
      </div>
      <div class="task-status">已完成</div>
      <div class="task-count" v-html="info.finished"></div>
    </div>
  </div>
</template>

<script>
//import PoiSearchResult from "./PoiSearchResult";

export default {
  name: "ZJEmergencyComponentTasksummary",
  componentName: "ZJEmergencyComponentTasksummary",
  components: {
    // ComponentPoiSearchResult: PoiSearchResult
  },
  props: {
    info: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {
        return {
          exception: 0,
          todo: 0,
          finished: 0
        };
      }
    }
  },
  data: function() {
    return {
      searchText: ""
    };
  },
  methods: {
    newtask: function() {
      this.$message({ message: "下发任务", type: "info" });
    }
  }
};
</script>